import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import { between } from '@ipfabric/utils/fp/number';
import type { TableCommandFactory } from 'components/Table/model/TableModel';
import { MIN_COLUMN_AUTO_SIZE } from 'components/Table/model/commands/autoSizeTableColumns';
import { getColumnWidthThatFitsContent } from 'components/Table/model/commands/helpers/getColumnWidthThatFitsContent';
import { pipe } from 'fp-ts/function';

interface AutoSizeSingleColumnCommand {
  key: string;
}

/**
 * Use bigger limit for auto sizing single column as we can expect user wants to see data in this particular column.
 */
const MIN_SINGLE_COLUMN_AUTO_SIZE = 1500;

export const autoSizeSingleColumn: TableCommandFactory<
  AutoSizeSingleColumnCommand
> =
  (cmdContext) =>
  ({ key }) => {
    const tableContainer =
      cmdContext.getState().tableContainerRef?.current ?? null;

    if (tableContainer === null) {
      stumble('Cannot auto-size table, missing wrapper element reference');
      return;
    }
    const width = pipe(
      key,
      getColumnWidthThatFitsContent(tableContainer),
      between(MIN_COLUMN_AUTO_SIZE, MIN_SINGLE_COLUMN_AUTO_SIZE),
    );

    cmdContext.updateState((draft) => {
      draft.settings.autoSizedColumns = false;
      draft.settings.columnWidth = draft.settings.columnWidth ?? {};
      draft.settings.columnWidth[key] = width;
    });
  };
